import { storage } from '@/lib/storage'

let cachedBrowserTimeZone: string | null = null

function getBrowserTimeZone(): string {
  if (cachedBrowserTimeZone == null) {
    try {
      cachedBrowserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
    } catch {
      cachedBrowserTimeZone = 'UTC'
    }
  }
  return cachedBrowserTimeZone
}

type StoredUserTimezonePrefs = {
  timezone?: string | null
  use_browser_timezone?: boolean | null
}

function getStoredUserTimezonePrefs(): StoredUserTimezonePrefs | null {
  try {
    const raw = storage.userJson()
    if (!raw) return null
    const parsed = JSON.parse(raw) as StoredUserTimezonePrefs
    return parsed ?? null
  } catch {
    return null
  }
}

/**
 * Часовой пояс интерфейса:
 * - по умолчанию: как на ПК пользователя (браузер);
 * - если в профиле выключено "использовать время с ПК" и выбран timezone — используем выбранный.
 */
export function getUserTimeZone(): string {
  const browserTz = getBrowserTimeZone()
  const prefs = getStoredUserTimezonePrefs()
  if (!prefs) return browserTz

  if (prefs.use_browser_timezone !== false) {
    return browserTz
  }
  const saved = (prefs.timezone || '').trim()
  if (!saved) return browserTz
  try {
    // Проверяем, что IANA TZ валиден в окружении браузера.
    new Intl.DateTimeFormat('ru-RU', { timeZone: saved }).format(new Date())
    return saved
  } catch {
    return browserTz
  }
}
